import { cn } from '@/lib/utils';
import { columnLabelClass } from '@/components/ui/typography.ts';

/** Nagłówek grupy kart — etykieta, dopisek i cienka linia do końca szerokości. */
const GroupSeparator = ({
  label,
  hint,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  label: string;
  hint: string;
}) => (
  <div
    className={cn('flex items-center gap-3 px-1 pb-0.5 pt-0.5', className)}
    {...props}
  >
    <span className={columnLabelClass}>{label}</span>
    <span className="text-[13px] text-neutral-500">{hint}</span>
    <span aria-hidden className="h-px flex-1 bg-neutral-300" />
  </div>
);

export default GroupSeparator;
